import { useDataLayerOneTrustConfirmationEvent } from '@/hooks';
import React from 'react';

export const useOneTrustReady = () => {
  const [ready, setReady] = React.useState(false);

  useDataLayerOneTrustConfirmationEvent(
    (_, unsubscribe = () => {}) => {
      setReady(true);
      unsubscribe();
    },
    { fireOnMount: true },
  );

  return { ready };
};
